class HeaderDrawerOverlay extends HeaderDrawer {
  constructor() {
    super();
    this.announcementCollapsedClass = 'announcement-bar-section--collapsed';
    this.menuLabel = this.querySelector('.header__icon-label--menu');
    this.menuLabelDefaultText = this.menuLabel ? this.menuLabel.textContent : null;
  }

  openMenuDrawer(summaryElement) {
    super.openMenuDrawer(summaryElement);
    this.setMenuLabelOpen(true);
    this.collapseAnnouncementBar();
    this.syncHeaderMenuColors(true);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    if (!elementToFocus) return;
    this.setMenuLabelOpen(false);
    this.restoreAnnouncementBar();
    this.syncHeaderMenuColors(false);
  }

  // Misma interaccion que el megamenu grande de escritorio: mientras el menu
  // esta abierto, el header (logo, label "Cerrar", iconos) pasa de blanco a
  // negro para que se lea sobre el vidrio esmerilado del overlay. La clase y
  // el CSS son los mismos que usa el escritorio (ver
  // header-wrapper--big-menu-open / header-wrapper--invert-menu-colors en
  // header.liquid y el toggle equivalente en details-disclosure.js), asi que
  // respeta el setting "invert_menu_colors" igual que alla.
  //
  // Se hace en open/close y no observando el atributo [open] del details
  // porque el tema lo saca 400ms despues de empezar a cerrar (closeAnimation
  // en global.js): asi el color vuelve a blanco en el mismo instante en que
  // el overlay empieza a desaparecer, y ambas transiciones corren juntas.
  syncHeaderMenuColors(isOpen) {
    this.headerWrapper = this.headerWrapper || this.closest('.header-wrapper');
    if (!this.headerWrapper) return;
    this.headerWrapper.classList.toggle('header-wrapper--big-menu-open', isOpen);
  }

  setMenuLabelOpen(isOpen) {
    if (!this.menuLabel) return;
    this.menuLabel.textContent = isOpen ? 'Cerrar' : this.menuLabelDefaultText;
  }

  collapseAnnouncementBar() {
    const bar = document.querySelector('.utility-bar');
    if (bar) bar.classList.add(this.announcementCollapsedClass);
  }

  restoreAnnouncementBar() {
    const bar = document.querySelector('.utility-bar');
    if (bar) bar.classList.remove(this.announcementCollapsedClass);
  }
}

customElements.define('header-drawer-overlay', HeaderDrawerOverlay);
